class MissionCards extends HTMLElement {
  constructor() {
    super();
    this.cards = this.querySelectorAll('.mission-card');
    this.onToggleClick = this.onToggleClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
  }

  connectedCallback() {
    this.cards.forEach((card) => {
      const button = card.querySelector('.mission-card__toggle');
      if (!button) return;
      button.addEventListener('click', this.onToggleClick);
      button.addEventListener('keydown', this.onKeydown);
    });
  }

  disconnectedCallback() {
    this.cards.forEach((card) => {
      const button = card.querySelector('.mission-card__toggle');
      if (!button) return;
      button.removeEventListener('click', this.onToggleClick);
      button.removeEventListener('keydown', this.onKeydown);
    });
  }

  onToggleClick(event) {
    const button = event.currentTarget;
    const card = button.closest('.mission-card');
    if (!card) return;
    this.toggle(card, button);
  }

  onKeydown(event) {
    if (event.key !== 'Escape') return;
    const card = event.currentTarget.closest('.mission-card');
    if (!card || !card.classList.contains('is-expanded')) return;
    this.toggle(card, event.currentTarget);
  }

  toggle(card, button) {
    const expanded = button.getAttribute('aria-expanded') === 'true';
    const next = !expanded;

    card.classList.toggle('is-expanded', next);
    button.setAttribute('aria-expanded', next ? 'true' : 'false');

    const content = card.querySelector('.mission-card__content');
    if (content) {
      content.setAttribute('aria-hidden', next ? 'false' : 'true');
      const link = content.querySelector('a');
      if (link) link.setAttribute('tabindex', next ? '0' : '-1');
    }
  }
}

if (!customElements.get('mission-cards')) {
  customElements.define('mission-cards', MissionCards);
}
